const companyGroupSettingQueryKeys = {
  all: [{ scope: 'companyGroupSetting' }] as const,
  settings: () => [{ ...companyGroupSettingQueryKeys.all[0], entity: 'settings' }] as const,
  setting: (companyId: string) => [{ ...companyGroupSettingQueryKeys.settings()[0], companyId }] as const
}

export default companyGroupSettingQueryKeys
